import { FC, useMemo } from 'react';
import FormSelect, { FormSelectProps } from 'components/new-ui/composed/formSelect/FormSelect';
import { getDeclarationSelectOptions } from 'store/declarations/common/get-declaration-select-options';
import { DeclarationCountry } from 'store/declarations/enums/common/declaration-country';
import { DeclarationInternalType } from 'store/declarations/enums/common/declaration-internal-type';
import { DeclarationStatuses } from 'store/declarations/enums/common/declaration-status';
import { declarationStatusColor } from 'components/ui/composed/declarations/declaration-status/DeclarationStatusTag';
import { colors } from 'theme';

type DeclarationStatusSelectProps = Omit<FormSelectProps, 'selectOptions'> & {
    country?: DeclarationCountry;
    internalType?: DeclarationInternalType;
};

const DeclarationStatusSelect: FC<DeclarationStatusSelectProps> = ({ country, internalType, ...rest }) => {
    const options = useMemo(() => getDeclarationSelectOptions(country, internalType), [country, internalType]);

    return (
        <FormSelect
            {...rest}
            hideKeys
            selectOptions={options}
            renderOptionContent={(item, label) => {
                const status = item.id as DeclarationStatuses;
                const color = declarationStatusColor[status] ?? colors.lightGrey;
                const text = String(label);

                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span
                            style={{
                                width: 8,
                                height: 8,
                                borderRadius: '50%',
                                backgroundColor: color,
                                flexShrink: 0,
                            }}
                        />
                        <span>{text}</span>
                    </div>
                );
            }}
        />
    );
};

export default DeclarationStatusSelect;
